import styled from 'styled-components';
import { Select } from 'antd';

export const FormLabel = styled.label`
font-weight: 700;
`;

export const WorkCenterSelect = styled(Select)`
  width: 200px;
  display: inline-block;
  margin-bottom: 1%;
`;